/* ============================================================
   Hongos del Sur – Escabeche de regalo automático v5
   ============================================================
   Reglas:
   - Subtotal (sin el Escabeche) >= ₲200.000 → agregar 1 Escabeche gratis
   - Subtotal cae < ₲200.000 → eliminar el Escabeche
   - Solo 1 regalo por pedido; el cliente no puede aumentar la cantidad
   - Si el cliente elimina el regalo manualmente, se re-agrega
   - Funciona en cart drawer y en /cart sin recargar la página
   - NO modifica precios vía JS (el precio gratuito viene del descuento BXGY)
   - Marca el regalo con propiedad privada _promo_gift para distinguirlo
   ============================================================ */
(function () {
  'use strict';

  /* ── Configuración ────────────────────────────────────────── */
  var GIFT_VARIANT_ID  = 43035609989218;
  var GIFT_HANDLE      = 'escabeche-de-hongos';
  var KNOWN_PRICE_PYG  = 65000;   // Precio real en PYG (del Admin API)
  var THRESHOLD_PYG    = 200000;  // Mínimo de compra en PYG
  var THRESHOLD        = null;    // Se calibra al detectar la escala de cart.js
  var PROP_HIDDEN      = '_promo_gift';   // Propiedad oculta (no aparece en recibo)
  var PROP_NOTE        = 'Promoción';     // Propiedad visible en el carrito
  var PROP_NOTE_VAL    = 'Regalo por compras desde G. 200.000';

  /* ── Estado interno ───────────────────────────────────────── */
  var origFetch = window.fetch.bind(window);
  var busy      = false;
  var pending   = false;

  /* ── Utilidades ───────────────────────────────────────────── */
  function jsonFetch(url, opts) {
    return origFetch(url, opts).then(function (r) { return r.json(); });
  }
  function afterSync() {
    busy = false;
    if (pending) { pending = false; syncGift(); }
  }

  /* ── 1. Auto-detección de escala de precios ───────────────────
     /products/{handle}.js devuelve price en las mismas unidades que cart.js.
     Admin API: ₲65.000 → "65000"
     Si cart.js usa ×100: price = 6500000 → scale = 100 → threshold = 20.000.000
     Si cart.js usa ×1:  price =   65000  → scale =   1 → threshold =    200.000  */
  function detectScale() {
    return origFetch('/products/' + GIFT_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var apiPrice = product.variants[0].price;
        var scale    = Math.max(1, Math.round(apiPrice / KNOWN_PRICE_PYG));
        THRESHOLD    = THRESHOLD_PYG * scale;
        console.log(
          '[HDS regalo] /products/' + GIFT_HANDLE + '.js → price:', apiPrice,
          '| Escala: ×' + scale,
          '| Umbral calculado:', THRESHOLD
        );
      })
      .catch(function () {
        THRESHOLD = THRESHOLD_PYG * 100; // Fallback conservador (×100)
        console.warn('[HDS regalo] Detección de escala falló. Usando fallback:', THRESHOLD);
      });
  }

  /* ── 2. Re-renderizar carrito vía Shopify Section Rendering ──
     Actualiza tanto el cart drawer como la página /cart sin recargar. */
  function refreshCart() {
    return origFetch('/?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var parser = new DOMParser();

        /* Cart drawer ─ reemplazar sub-secciones para no destruir el custom element */
        if (data['cart-drawer']) {
          var d = parser.parseFromString(data['cart-drawer'], 'text/html');
          ['CartDrawer-CartItems', 'CartDrawer-Footer', 'CartDrawer-Empty'].forEach(function (id) {
            var a = document.getElementById(id);
            var b = d.getElementById(id);
            if (a && b) a.innerHTML = b.innerHTML;
          });
        }

        /* Página /cart */
        ['main-cart-items', 'main-cart-footer'].forEach(function (sec) {
          if (!data[sec]) return;
          var d2  = parser.parseFromString(data[sec], 'text/html');
          var el  = document.getElementById(sec);
          var nel = d2.getElementById(sec);
          if (el && nel) el.innerHTML = nel.innerHTML;
        });

        /* Badge de íconos */
        return jsonFetch('/cart.js');
      })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          var sp = el.querySelector('span:first-child');
          if (sp) sp.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        /* Notificar a Dawn para que re-evalúe su estado interno */
        if (typeof window.publish === 'function' &&
            window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
          publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'auto-gift-promo' });
        }
        applyGiftUI();
      })
      .catch(function () {});
  }

  /* ── 3. UI: deshabilitar botón + y mostrar etiqueta de regalo ── */
  function applyGiftUI() {
    setTimeout(function () {
      document.querySelectorAll('.cart-item').forEach(function (item) {
        /* Identificar el item del Escabeche por su URL de producto */
        if (!item.querySelector('a[href*="' + GIFT_HANDLE + '"]')) return;

        /* Deshabilitar el botón de aumentar cantidad */
        var plusBtn = item.querySelector('[name="plus"]');
        if (plusBtn && !plusBtn.disabled) {
          plusBtn.disabled = true;
          plusBtn.style.cssText += ';opacity:0.25;pointer-events:none;cursor:default;';
        }
        /* Fijar máximo en el input de cantidad */
        var qtyInput = item.querySelector('input[type="number"]');
        if (qtyInput) qtyInput.setAttribute('max', '1');

        /* Inyectar etiqueta de regalo si no existe aún */
        if (!item.querySelector('.hds-gift-label')) {
          var label = document.createElement('p');
          label.className = 'hds-gift-label';
          label.style.cssText = 'font-size:11px;color:#35100f;font-weight:600;margin:4px 0 0;';
          label.textContent = '🎁 ' + PROP_NOTE_VAL;
          var details = item.querySelector('.cart-item__details, .cart-item__description, .product-cart-details');
          if (details) details.appendChild(label);
        }
      });
    }, 150);
  }

  /* ── 4. Lógica de sincronización principal ────────────────── */
  function syncGift() {
    if (THRESHOLD === null) return; /* Esperar calibración */
    if (busy) { pending = true; return; }
    busy = true;

    jsonFetch('/cart.js').then(function (cart) {
      var giftItem = null;
      var subtotal = 0;

      cart.items.forEach(function (item) {
        if (item.variant_id == GIFT_VARIANT_ID) {
          if (!giftItem) giftItem = item; /* Registrar el primero */
        } else {
          subtotal += item.line_price; /* No contar el Escabeche */
        }
      });

      if (subtotal >= THRESHOLD && !giftItem) {
        /* ── Agregar Escabeche de regalo ── */
        var props = {};
        props[PROP_HIDDEN] = 'si';
        props[PROP_NOTE]   = PROP_NOTE_VAL;
        jsonFetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({
            items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: props }]
          })
        }).then(refreshCart).then(afterSync, afterSync);

      } else if (subtotal < THRESHOLD && giftItem) {
        /* ── Eliminar Escabeche (incluso si fue agregado manualmente) ── */
        var updates = {};
        updates[String(GIFT_VARIANT_ID)] = 0;
        jsonFetch('/cart/update.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ updates: updates })
        }).then(refreshCart).then(afterSync, afterSync);

      } else {
        /* Sin cambios → solo aplicar UI si corresponde */
        if (giftItem) applyGiftUI();
        afterSync();
      }
    }).catch(afterSync);
  }

  /* ── 5. Interceptor de window.fetch ─────────────────────────
     Detecta cuando Dawn modifica el carrito (add/change/update/clear)
     y programa una sincronización 350 ms después. */
  window.fetch = function () {
    var args    = Array.prototype.slice.call(arguments);
    var promise = origFetch.apply(window, args);
    var url     = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(url) && !busy) {
      promise.then(function () { setTimeout(syncGift, 350); }, function () {});
    }
    return promise;
  };

  /* ── 6. Suscripción al pubsub de Dawn ────────────────────────
     Canal adicional para capturar cambios que Dawn emite internamente. */
  function trySubscribe() {
    if (typeof window.subscribe === 'function' &&
        window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (p) {
        if (p && p.source === 'auto-gift-promo') return;
        if (!busy) setTimeout(syncGift, 200);
      });
      return true;
    }
    return false;
  }
  var subTries = 0;
  function initSub() {
    if (!trySubscribe() && ++subTries < 20) setTimeout(initSub, 400);
  }

  /* ── Inicio ──────────────────────────────────────────────────
     1. Detectar escala de precios
     2. Sincronizar el carrito
     3. Suscribirse al pubsub de Dawn */
  function init() {
    detectScale().then(function () {
      setTimeout(syncGift, 500);
      initSub();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
